/** @internal */
export enum LogEntryOptions {
    log = 'log',
    warn = 'warn',
    error = 'error',
    throw = 'throw',
}
